import { styled } from "styled-components";

export const MyToneTypeEditContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 18px;
`;
